module.exports = __webpack_public_path__ + "static/media/paritet.1594254d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paritet.png
// module id = 323
// module chunks = 0